
const a_Category_Data = [
    ['Men', 1],
    ['Clothing', '1-a'],
    ['Shoes', '1-b'],
    ['Accessories', '1-c'],
    ['Bags', '1-d'],
    ['Watches', '1-e'],
    ['Fragrances', '1-f'],
    ['Grooming', '1-g'],
    ['Sportswear', '1-h'],
    ['Underwear', '1-i'],
    ['Tech Gadgets', '1-j']
    ['WomMen', 2],
    ['Dresses', '2-a'],
    ['Tops', '2-b'],
    ['Bottoms', '2-c'],
    ['Shoes', '2-d'],
    ['Handbags', '2-e'],
    ['Jewelry', '2-f'],
    ['Beauty Products', '2-g'],
    ['Lingerie', '2-h'],
    ['Activewear', '2-i'],
    ['Sunglasses', '2-j']
];
export default a_Category_Data;